export const environment = {
  production: true
};



// WEBPACK FOOTER //
// ./client-src/environments/environment.ts